import { useState } from "react";
import {
    Button,
    Divider,
    Popover,
    Group,
    useMantineTheme,
    TextInput
} from "@mantine/core";

const ConfirmPopover = ({
    trigger,
    callback,
    typeName = null,
    text = "Are you sure you want to do this action?",
    withinPortal = false,
    focusColor = "blue"
}) => {

    const [open, setOpen] = useState(false);
    const [confirmValue, setConfirmValue] = useState("");

    const theme = useMantineTheme();

    const borderColor = focusColor
        ? `var(--mantine-color-${focusColor}-6)`
        : "var(--mantine-primary-color-filled)";

    const glowColor = focusColor
        ? `var(--mantine-color-${focusColor}-3)`
        : "var(--mantine-primary-color-filled)";

    const canConfirm = !typeName || confirmValue === typeName;

    function handleConfirm() {
        if (!canConfirm) return;

        setOpen(false);
        setConfirmValue("");
        callback();
    }

    function handleClose() {
        setOpen(false);
        setConfirmValue("");
    }

    return (
        <Popover
            opened={open}
            onChange={(value) => {
                setOpen(value);

                if (!value) {
                    setConfirmValue("");
                }
            }}
            withinPortal={withinPortal}
        >
            <Popover.Target>
                <span onClick={() => setOpen(true)}>
                    {trigger}
                </span>
            </Popover.Target>

            <Popover.Dropdown
                style={{
                    background: "var(--mantine-color-body)",
                    border: `1.5px solid ${borderColor}`,
                    boxShadow: `0 0 0 3px color-mix(in srgb, ${glowColor} 30%, transparent), var(--mantine-shadow-xl)`,
                }}
            >
                <b>{text}</b>

                {typeName && (
                    <TextInput
                        mt="sm"
                        label={`Type "${typeName}" to confirm`}
                        placeholder={`Enter ${typeName}`}
                        value={confirmValue}
                        onChange={(e) => setConfirmValue(e.currentTarget.value)}
                    />
                )}

                <Divider my="md" />

                <Group justify="center">
                    <Button
                        type="button"
                        data-cy="confirm-popover-yes-button"
                        color={theme.colors.green[7]}
                        disabled={!canConfirm}
                        onClick={handleConfirm}
                    >
                        Yes
                    </Button>

                    <Button
                        type="button"
                        color={theme.colors.red[7]}
                        onClick={handleClose}
                    >
                        No
                    </Button>
                </Group>
            </Popover.Dropdown>
        </Popover>
    );
};

export default ConfirmPopover;